export default "__VITE_ASSET__DTycetC9__"